import { BadgeCheck, LoaderCircle, LockKeyhole, Sparkles } from "lucide-react";

import type { FriendAccessStatus } from "./friendAccess";
import { AppLink } from "../ui/router";

export function PlanStatusBadge({
  access,
  administrator = false,
  busy = false,
  onAdministratorToggle,
}: {
  access?: FriendAccessStatus;
  administrator?: boolean;
  busy?: boolean;
  onAdministratorToggle?: () => void;
}) {
  const household = access?.fullAccess === true || access?.planCode === "household";
  const label = household ? "Household plan" : "Free plan";
  const Icon = busy ? LoaderCircle : household ? BadgeCheck : Sparkles;
  const className = `plan-status-badge interactive ${household ? "household" : "free"}`;
  const contents = <><Icon className={busy ? "spin" : undefined} size={15} aria-hidden="true" /><span>{busy ? "Changing plan..." : label}</span></>;

  if (administrator) {
    const nextLabel = household ? "Free plan" : "Household plan";
    return <button type="button" className={className} disabled={busy || !access} onClick={onAdministratorToggle} aria-label={`Current plan: ${label}. Switch administrator preview to ${nextLabel}.`} title={`Switch administrator preview to ${nextLabel}`}>{contents}</button>;
  }

  return <AppLink href="/settings#billing" className={className} aria-label={`Current plan: ${label}. Open billing settings.`} title="Open Settings and Billing">{contents}</AppLink>;
}

export function HouseholdUpgrade({
  title,
  body,
}: {
  title: string;
  body: string;
}) {
  return <section className="panel household-upgrade">
    <LockKeyhole size={22} />
    <div><h2>{title}</h2><p>{body}</p></div>
    <AppLink href="/pricing" className="button primary">See Household</AppLink>
  </section>;
}

export function FreeGenerationUsage({ remaining, limit = 5 }: { remaining: number; limit?: number }) {
  const used = Math.max(0, limit - remaining);
  return <section className="free-usage" aria-label="Free monthly meal generations">
    <div><strong>Free plan</strong><span>{remaining} of {limit} single-meal generations remaining this month</span></div>
    <div className="free-usage-track" aria-hidden="true"><span style={{ width: `${Math.min(100, (used / limit) * 100)}%` }} /></div>
    <AppLink href="/pricing">View Household</AppLink>
  </section>;
}
